import { useToast } from "@/plugins/useToast";
import Httpservice from "@/services/httpservice.js";
import { buildQueryParams, extractErrorMessage } from "@/utils/httpHelper.js";
const API_URL = import.meta.env.VITE_API_URL;

const {showToast} = useToast();

const getTarefas = async (pageNumber, pageSize, situacao, responsavelId, searchTerm, filters) => {
    try {
        const params = buildQueryParams({
            pageNumber,
            pageSize,
            situacao,
            searchTerm,
            responsavelId,
            filters
        });

        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/list`,{
            params: params
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar tafefas:', error);
        throw error;
    }
};

const getHistoricos = async (agendaId, pageNumber, pageSize, searchTerm) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/historico/${agendaId}`,{
            params: {
                pageNumber,
                pageSize,
                searchTerm
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar históricos:', error);
        throw error;
    }
};

const getTarefa = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/detalhes`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar tarefa', error);
        throw error;
    }
};

const getTarefaPrepararEnvioFollowAgrupado = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/follow-up-agrupado/preparar-envio`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar tarefa', error);
        throw error;
    }
};

const getPrepararEnvioNF = async (id) => {
  try {
    const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/adiar-solicitacao-nf/preparar-envio`,{ });
    return response.data;
  } catch (error) {
    console.error('Ocorreu um erro ao preparar o envio da NF.', error);
    throw error;
  }
};

const getPrepararEnvioNFFinanceiro = async (id) => {
  try {
    const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/enviar-nf-financeiro/preparar-envio`,{ });
    return response.data;
  } catch (error) {
    console.error('Ocorreu um erro ao preparar o envio da NF.', error);
    throw error;
  }
};

const getPrepararEnvioFechamentoMontadoFinanceiro = async (id) => {
  try {
    const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/fechamento-montado-financeiro/preparar-envio`,{ });
    return response.data;
  } catch (error) {
    console.error('Ocorreu um erro ao preparar o fechamento financeiro.', error);
    throw error;
  }
};

const solicitarCambio = async (tarefaId, processoId, values) => {
  try {
    const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/concluir/${processoId}/solicitacao-cambio`, values);
    return response.data;
  } catch (error) {
    console.error('Ocorreu um erro ao solicitar cambio.', error);
    throw error;
  }
};

const newProcess = async (values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/processo`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o processo', error);
        throw error;
    }
};

const solicitarLiberacao = async (processoId, justificativa) => {
    try {
        const response = await Httpservice.getAxiosClient().post(
            `${API_URL}/api/agenda/processo/${processoId}/solicitar-liberacao`,
            { justificativa }
        );
        return response.data;
    } catch (error) {
        console.error('Erro ao solicitar liberação', error);
        throw error;
    }
};

const liberarSolicitacao = async (liberacaoId, senha) => {
    try {
        const response = await Httpservice.getAxiosClient().post(
            `${API_URL}/api/agenda/liberacoes-gerencia/${liberacaoId}/liberar`,
            { senha }
        );
        return response.data;
    } catch (error) {
        console.error('Erro ao liberar solicitação', error);
        throw error;
    }
};

const adiarTarefa = async (tarefaId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/adiar`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar o processo', error);
        throw error;
    }
};

const cancelarTarefa = async (tarefaId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/cancelar`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao cancelar a tarefa', error);
        throw error;
    }
};

const concluirTarefa = async (tarefaId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/concluir`,values);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar a tarefa', error);
        throw error;
    }
};

const concluirFechamentoProcesso = async (tarefaId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/concluir/fechamento-processo`,values);
        showToast("Fechamento Concluído", {
            title: 'Sucesso',
            type: 'success'
        })
        return response.data;
    } catch (error) {
        console.error('Ocorreu um erro ao fechar o processo.', error);
        showToast(`Erro ao providenciar fechamento do processo ${extractErrorMessage(error)}`, {
            title: 'Erro',
            type: 'error'
        })
        throw error;
    }
};

const updateTarefa = async (processId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/agenda/${processId}`, values);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar tarefa', error);
        throw error;
    }
};

const updateSituacaoMapa = async (processoId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/processo/${processoId}/mapa`, values);

        return response.data;
    } catch (error) {
        console.error('Erro ao salvar alteração no mapa', error);
        throw error;
    }
};

const atribuirResponsavel = async (processoId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/processo/${processoId}/responsavel`, values);

        return response.data;
    } catch (error) {
        console.error('Erro ao salvar alteração no mapa', error);
        throw error;
    }
};

const getListTarefaSituacao = () => {
    return [
        { nome: 'Pendente', id: 1 },
        { nome: 'Adiada', id: 6 },
        { nome: 'Concluída', id: 3},
        { nome: 'Atrasada', id: 4},
    ];
}

const geTarefaSituacao =  (optional) => {
    if(optional === true) {
        return  [{nome: 'Selecione', id: null}, ...getListTarefaSituacao()]
    }
    return getListTarefaSituacao()
};

const getPrepararEnvioAverbacaoSeguro = async (id) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/averbacao-seguro/preparar-envio`,{ });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar tarefa', error);
        throw error;
    }
};

const concluirAverbacaoSeguro = async (tarefaId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/concluir/averbacao-seguro`,values);
        console.log("Response: ", response);
        
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar a tarefa.', error);
        throw error;
    }
};

const getChecklist = async (processoId) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/processo/${processoId}/checklist`);
        return response.data;
    } catch (error) {
        console.error('Erro ao obter o checklist', error);
        throw error;
    }
}

const salvarChecklist = async (processoId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/processo/${processoId}/atualizar-checklist`, values);
        return response;
    } catch (error) {
        console.error('Erro ao salvar o checklist', error);
        throw error;
    }
}

const adiarChecklist = async (processoId, values) => {
    try {
        const response = await Httpservice.getAxiosClient().put(`${API_URL}/api/processo/${processoId}/adiar-checklist`, values);
        return response;
    } catch (error) {
        console.error('Erro ao adiar', error);
        throw error;
    }
}

const isChecklistDone = async (processoId) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/processo/${processoId}/checklist/isDone`);
        return response.data;
    } catch (error) {
        console.error('Erro ao obter validação do checklist', error);
        throw error;
    }
}

const getRegimeParaConclusao = async (processoId) => {
    try {
        const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${processoId}/concluir/escolher-regime`);
        return response.data;
    } catch (error) {
        console.error('Erro ao obter validação do checklist', error);
        throw error;
    }
}

const reabrirTarefa = async (tarefaId, values) => {
  const { showToast } = useToast();
  try {
    const response = await Httpservice.getAxiosClient().post(`${API_URL}/api/agenda/tarefa/${tarefaId}/reabrir`,values);

    showToast("Tarefa reaberta com sucesso", { title: 'Sucesso', type: 'success' });
    return response.data;
  } catch (error) {
    console.error('Erro ao reabrir a tarefa', error);
    showToast(extractErrorMessage(error), { title: 'Erro', type: 'error' });
    throw error;
  }
};

const getPrepararEnvioCotarFreteNacional = async (id) => {
  try {
    const response = await Httpservice.getAxiosClient().get(`${API_URL}/api/agenda/tarefa/${id}/cotacao-frete-nacional/preparar-envio`,{ });
    return response.data;
  } catch (error) {
    console.error('Ocorreu um erro ao preparar o envio da cotação de frete nacional.', error);
    throw error;
  }
};

export default {
    getTarefas,
    solicitarLiberacao,
    liberarSolicitacao,
    getTarefa,
    geTarefaSituacao,
    adiarTarefa,
    cancelarTarefa,
    concluirTarefa,
    concluirFechamentoProcesso,
    newProcess,
    updateTarefa,
    getHistoricos,
    updateSituacaoMapa,
    atribuirResponsavel,
    getTarefaPrepararEnvioFollowAgrupado,
    getPrepararEnvioNF,
    solicitarCambio,
    getPrepararEnvioAverbacaoSeguro,
    concluirAverbacaoSeguro,
    getChecklist,
    salvarChecklist,
    adiarChecklist,
    isChecklistDone,
    getRegimeParaConclusao,
    getPrepararEnvioNFFinanceiro,
    getPrepararEnvioFechamentoMontadoFinanceiro,
    reabrirTarefa,
    getPrepararEnvioCotarFreteNacional
};